export default __webpack_public_path__ + "static/media/image-large.a642eedb.svg";